<app-title>{{titleText}}</app-title>
<div id="content" *ngIf="(account$ | async) as account; else accountNotFound">
  <ng-container *ngIf="!loadingError; else imageNotFound">
    <app-image-grid [urls]="account?.images"></app-image-grid>
  </ng-container>
  <ng-template #imageNotFound>
    <div class="not-found" mat-card-image>
      <div>
        <mat-icon inline="true">photo_camera</mat-icon>
        <div>No photo</div>
      </div>
    </div>
  </ng-template>
  <app-account-detail-form #accountForm [account]="account" [readonly]="readonly"></app-account-detail-form>
  <div class="button-container">
    <div style="flex-grow:1"></div>
    <button mat-raised-button color="primary" [disabled]="readonly" (click)="onClickDeleteButton()">削除</button>
    <button mat-raised-button color="primary" [disabled]="formGroup?.invalid || readonly"
      (click)="onClickUpdateButton()">更新</button>
  </div>
</div>
<ng-template #accountNotFound>
  <div>
    <div>レコードが見つかりませんでした。</div>
  </div>
</ng-template>